const getCsrfTokenFromCookie = (cookieString: string): string => {
  const q = {}
  cookieString?.replace(/\s/g, '')
    .split(';')
    .map(i=>i.split('='))
    .forEach(([key, value]) => {
      q[key] = value
    })
  return q['csrftoken'] ?? null;
}

export default getCsrfTokenFromCookie

